import FlowNode from './flowNode';
import RedirectNode from './redirectNode';
import QuestionNode from './questionNode';
import InputNode from './inputNode';
import PageNode from './pageNode';

const NODE_MAPPING = {
  RedirectNode, QuestionNode, InputNode, PageNode
};

const getNodeInstance = (node, index) => {
  const NodeModel = NODE_MAPPING[node.type] || FlowNode;
  return new NodeModel(index, node);
};

export const getParsedNodes = (flow) =>
  flow ? flow.map(getNodeInstance) : [];

